import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const state = {
  token: '',
  username: '明世隐',
  userState: 0,
  menuData: [],
  isLoadRoute: false
}
const mutations = {
  setUser (state, name) {
    state.username = name
  },
  setUserState (state, data) {
    state.userState += data
  },
  setMenuData (state, data) {
    state.menuData = data
  },
  setLoadRoute (state, data) {
    state.isLoadRoute = data
  },
  SET_TOKEN (state, token) {
    state.token = token
    localStorage.setItem('token', token)
  },
  resetState (state) {
    state.token = ''
    localStorage.clear()
  }

}
const getters = {
  getUserState (state) {
    let data
    if (state.userState === 0) {
      data = '无效'
    } else {
      data = state.userState + '级'
    }
    return data
  }
}

export default new Vuex.Store({
  state,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js